module.exports = __webpack_public_path__ + "static/media/cheeseResized.fe415b20.gif";